import { render, staticRenderFns } from "./pointlist.vue?vue&type=template&id=0f649708"
import script from "./pointlist.vue?vue&type=script&lang=js"
export * from "./pointlist.vue?vue&type=script&lang=js"
import style0 from "./pointlist.vue?vue&type=style&index=0&id=0f649708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports